import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);
const isLocal = process.env.VUE_APP_LOCAL_ONLY;
const devmode = {name: "login"};
// const devmode = {}

const redirectToLogin = (to, from, next) => {
  if (!document.cookie.includes("cn-token")) {
    if (to.name !== "login") {
      next({ name: "login", query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
};

const routes = [
  {
    path: "/",
    name: "dashboard",
    component: () => import("../views/DashboardView.vue"),
    beforeEnter: (to, from, next) => {
      if (!document.cookie.includes("cn-token")) {
        next({name: "login"});
      } else {
        store
          .dispatch("getApiCallAction", {hook: "/user/session"})
          .then((res) => {
            if (res && res.hasStore === 1) {
              next({name: "cs"});
            } else {
              next();
            }
          })
          .catch(() => {
            next({name: "NotFound"});
          });
      }
    },
  },
  {
    path: "/transactions",
    name: "transactions",
    component: () => import("../views/transactions/TransactionsView.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/webhooks",
    name: "webhooks",
    component: () => import("../views/webhooks/WebhooksView.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/payment-requests",
    name: "payment-requests",
    component: () => import("../views/pay-link/PaymentRequestsView.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/payment-requests/new",
    name: "payment-requests-new",
    component: () => import("../views/pay-link/PaymentRequestsNew.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("@/views/alerts/Notifications.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/notifications/:id",
    name: "notification",
    component: () => import("@/views/alerts/Notification.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/admin-alerts",
    name: "payment-buttons",
    component: () => import("@/views/alerts/AdminAlerts.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/admin-alerts/:id",
    name: "alert",
    component: () => import("@/views/alerts/AlertsModify.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/payment-buttons",
    name: "payment-buttons",
    component: () => import("@/views/pay-button/PaymentButtonsView.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/invoice-form",
    name: "invoice-form",
    component: () => import("@/views/invoice-form/InvoiceForm.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/payment-buttons/new",
    name: "payment-buttons-new",
    component: () => import("@/views/pay-button/PaymentButtonsNew.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/web-pos",
    name: "web-pos",
    component: () => import("../views/web-pos/WebPos.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/web-pos/new",
    name: "web-pos-new",
    component: () => import("../views/web-pos/WebPosNew.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/web-pos/:id",
    name: "web-pos-edit",
    component: () => import("../views/web-pos/WebPosEdit.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/webhooks/new",
    name: "webhooks-new",
    component: () => import("../views/webhooks/WebhooksNew.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/admin-transactions",
    name: "admin-transactions",
    component: () => import("../views/transactions/AdminTransactionsView.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/merchant-list",
    name: "merchant-list",
    component: () => import("../views/merchant/MerchantList.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/accounting",
    name: "accountingCenter",
    component: () => import("../views/AccountingCenterView.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/commissions",
    name: "commissions",
    component: () => import("../views/CommissionsView.vue"),
    beforeEnter: redirectToLogin,
  },
  // {
  //   path: "/invoices",
  //   name: "invoices",
  //   component: () => import("../views/InvoiceView.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (!document.cookie.includes("cn-token")) next(devmode);
  //     else next();
  //   },
  // },
  {
    path: "/referral",
    name: "referral",
    component: () => import("../views/ReferralView.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/support",
    name: "support",
    component: () => import("../views/SupportView.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/td/:id",
    name: "td",
    component: () => import("../views/transactions/TransactionDetail.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/wd/:id",
    name: "wd",
    component: () => import("../views/webhooks/WebhooksModify.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/payment-requests/:id",
    name: "pd",
    component: () => import("../views/pay-link/PaymentRequestsModify.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/payment-buttons/:id",
    name: "pb",
    component: () => import("@/views/pay-button/PaymentButtonsModify.vue"),
    beforeEnter: redirectToLogin,
  },
  {
    path: "/md/:id",
    name: "md",
    component: () => import("../views/merchant/MerchantDetail.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/invoice-details/:id",
    name: "invoice-details",
    component: () => import("../views/InvoiceDetail.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("../views/SettingsView.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/cs",
    name: "cs",
    component: () => import("../views/DashboardConnectedView.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue")
  },
  // {
  //   path: "/lightninglogin",
  //   name: "lightninglogin",
  //   component: () => import("../views/LightningLoginView.vue"),
  //   beforeEnter: (to, from, next) => {
  //     if (document.cookie.includes("cn-token")) next({ name: "dashboard" });
  //     else next();
  //   },
  // },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/RegisterView.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/RegistrationSuccesfulView.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "enterCode",
    name: "enterCode",
    component: () => import("../views/EnterCodeView.vue"),
  },
  {
    path: "newReg",
    name: "newReg",
    component: () => import("../views/NewRegisterView.vue"),
  },
  {
    path: "regSec",
    name: "regSec",
    component: () => import("../views/RegistrationSuccesfulView.vue"),
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: () => import("../views/ForgotPasswordView.vue"),
  },
  {
    path: "/reset/*",
    name: "Reset",
    component: () => import("../views/ResetPasswordView.vue"),
  },
  {
    path: "/verify/account/*",
    name: "Verify",
    component: () => import("../views/VerifyEmailView.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    meta: {notFound: true},
    component: () => import("../views/PageNotFoundView.vue"),
  },
  {
    path: "/reports",
    name: "reports",
    component: () => import("../views/ReportsView.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/monthly-statements",
    name: "Money-Statements",
    component: () => import("../views/MonthlyStatements.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/admin/Admin.vue"),
    beforeEnter: redirectToLogin,

  },
  {
    path: "/stats",
    name: "Stats",
    component: () => import("../views/stats/Stats.vue"),
    beforeEnter: redirectToLogin,

  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
export default router;
